import { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { getBuyer, joinLive } from "../axios/api";
import AgoraRTC from "agora-rtc-sdk-ng";
import { options, rtc } from "../constant";
import { Button, TextField, Grid2, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import io from "socket.io-client";
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductGrid from "../components/productDisplay";
import CallEndIcon from '@mui/icons-material/CallEnd';
import goliveAnimation from "../components/lottie/live.json"
import Lottie from "lottie-react";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import StreamEndPopup from "../components/streamEndPop";

const JoinLive = () => {
    const [liveData, setLiveData] = useState();
    const [streamMuted, setStreamMuted] = useState(false);
    const [comment, setComment] = useState('');
    const [comments, setComments] = useState([]);
    const location = useLocation();
    const { id } = useParams();
    const [token, setToken] = useState('');
    const [numUsers, setNumUsers] = useState(0);
    const [loading, setLoading] = useState(true)
    const [showEndLiveButton, setShowEndLiveButton] = useState(false);
    const remoteAudioTracks = new Map();
    const commentsEndRef = useRef(null);
    const [isUserScrolling, setIsUserScrolling] = useState(false);
    const [userInfo, setUserInfo] = useState()
    const [liked, setLiked] = useState(false)
    const [likeCount, setLikeCount] = useState(0)
    const [open, setOpen] = useState(false)


    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (userInfo) {
            const socketConnection = io(process.env.REACT_APP_SOCKET_URL);
            setSocket(socketConnection)
            socketConnection.on("connect", () => {
                console.log("Connected to socket server");
                socketConnection.emit('join_stream', { streamId: id, userId: userInfo._id });
            });

            socketConnection.on("receive_comments", (comments) => {
                console.log("Received previous comments:", comments);
                setComments(comments);
            });
            socketConnection.on("user_count", (count) => {
                console.log("User count updated:", count);
                setNumUsers(count);
            });
            socketConnection.on("is_liked", (data) => {
                console.log("User Like updated:", data);
                setLiked(data.isLiked)
            });
            socketConnection.on("receive_comment", (newComment) => {
                console.log("Received new comment:", newComment);
                setComments((prevComments) => [...prevComments, newComment]);
            });

            socketConnection.on('stream_ended', (data) => {
                console.log(data, "dsatadsatadsatadsata");
                setOpen(true)
            });


            return () => {
                console.log("Disconnecting from socket server...");
                socketConnection.disconnect();
            };
        }
    }, [id, userInfo]);


    useEffect(() => {
        if (socket) {
            socket.emit("get_like_count", { streamId: id });

            socket.on("update_like_count", (likeCount) => {
                console.log("Updated like count:", likeCount);
                setLikeCount(likeCount);
            });
            return () => {
                socket.off("update_like_count");
            };
        }
    }, [socket, id]);


    useEffect(() => {
        const commentsContainer = document.getElementById("comments");

        const handleScroll = () => {
            if (!commentsContainer) return;

            const isAtBottom =
                commentsContainer.scrollHeight - commentsContainer.scrollTop <=
                commentsContainer.clientHeight + 10; // Allow some tolerance

            setIsUserScrolling(!isAtBottom);
        };

        if (commentsContainer) {
            commentsContainer.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (commentsContainer) {
                commentsContainer.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

    useEffect(() => {
        if (!isUserScrolling && commentsEndRef.current) {
            commentsEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [comments]);



    const handleJoinLive = async () => {
        if (!liveData || !liveData.streamId) {
            console.error("Missing live data or token");
            return;
        }

        try {
            await rtc.client.join(options.appId, liveData.streamId, liveData.token, liveData.uid);

            rtc.client.on("user-published", async (user, mediaType) => {
                console.log("Remote user published:", user.uid);

                await rtc.client.subscribe(user, mediaType);

                if (mediaType === "video" || mediaType === "all") {
                    const remoteVideoTrack = user.videoTrack;
                    if (remoteVideoTrack) {
                        console.log("Playing remote video track for UID:", user.uid);
                        const playerContainer = document.createElement("div");
                        playerContainer.id = `remote-${user.uid}`;
                        playerContainer.classList.add("remote-player");
                        playerContainer.style.width = "100%";
                        playerContainer.style.height = "100%";
                        document.getElementById("remote-stream").appendChild(playerContainer);
                        remoteVideoTrack.play(playerContainer.id);
                    }
                }

                if (mediaType === "audio" || mediaType === "all") {
                    const remoteAudioTrack = user.audioTrack;
                    remoteAudioTracks.set(user.uid, remoteAudioTrack);
                    if (!streamMuted) {
                        remoteAudioTrack.play();
                    }
                }
            });

            rtc.client.on("user-unpublished", (user) => {
                console.log("Remote user unpublished:", user.uid);
                remoteAudioTracks.delete(user.uid);
                const playerContainer = document.getElementById(`remote-${user.uid}`);
                if (playerContainer) {
                    playerContainer.remove();
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    const handleLeave = async () => {
        try {
            const localContainer = document.getElementById("remote-stream");
            if (localContainer) {
                localContainer.innerHTML = "";
            }

            rtc.client.remoteUsers.forEach((user) => {
                const playerContainer = document.getElementById(`remote-${user.uid}`);
                if (playerContainer) {
                    playerContainer.remove();
                }
            });

            await rtc.client.leave();
            socket.emit('leave_stream', { streamId: id, userId: userInfo._id });
            window.close();
            console.log("Left the channel successfully");
        } catch (error) {
            console.error("Error leaving channel:", error);
        }
    };

    const fetchData = async (id) => {
        try {
            const response = await joinLive(id);
            if (response.data) {
                setLiveData(response.data);
            }
        } catch (error) {
            console.error(error);
        }
    };




    const handleSendComment = () => {
        if (!comment.trim()) return;

        socket.emit("send_comment", {
            comment,
            user: userInfo,
            timestamp: new Date().toLocaleTimeString(),
            streamId: id,
        });

        setComment('');
    };

    const handleLikeStream = () => {
        socket.emit("like_stream", { streamId: id, userId: userInfo._id, action: !liked })
        setLiked(!liked)
    }



    const fetchBuyerInfo = async () => {
        try {
            const response = await getBuyer()
            if (response.data) {
                setUserInfo(response.data)
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchBuyerInfo()
    }, [])

    useEffect(() => {
        if (commentsEndRef.current) {
            commentsEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [comments]);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tokenFromUrl = urlParams.get('token');
        if (tokenFromUrl) {
            localStorage.setItem("token", tokenFromUrl);
        }
        setToken(tokenFromUrl);
    }, [location.search]);

    useEffect(() => {
        if (id && token) {
            fetchData(id);
        }
    }, [id, token]);

    useEffect(() => {
        if (liveData) {
            rtc.client = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
            handleJoinLive();
        }
    }, [liveData]);


    useEffect(() => {
        if (loading && id && token && liveData) {
            setLoading(false)
        }
    }, [loading, id, token, liveData])


    useEffect(() => {
        if (rtc.client) {
            console.log("code hits");
            // Listen for the 'userOffline' event, which fires when the host leaves
            rtc.client.on("userOffline", (user) => {
                console.log(user, liveData.stream.sellerId, "dsdasdasdasdas");
                if (user.uid === liveData?.stream.sellerId?.uid) {
                    console.log("The host has ended the stream.");
                    // You can handle this by showing a message or redirecting the user
                    alert("The host has ended the stream.");
                    handleLeave(); // Optional: automatically leave the channel
                }
            });
        }
    }, [rtc.client, liveData]);


    const styles = {
        loaderContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: 'black',
            color: 'white',
            textAlign: 'center',
        },
        message: {
            marginTop: '20px',
            fontSize: '20px',
            fontWeight: 'bold',
        }
    };



    if (loading) {
        return (
            <div style={styles.loaderContainer}>
                <Lottie
                    animationData={goliveAnimation}
                    loop={true}  // Set loop to true to keep playing
                    autoplay={true}  // Ensures the animation starts automatically
                    style={{ height: "200px" }}
                />
                <p style={styles.message}>Joining Live Stream...</p>
            </div>
        );
    }

    return (
        <div className="container-fluid pt-sm-2 ps-sm-2 p-0" style={{ width: "100%", background: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Grid2 className="stream-block-main" container spacing={1} style={{ width: "100%" }}>

                {/* First Grid: Product Display (Scrollable Content) */}


                {/* Second Grid: Video/Stream Section */}
                <Grid2 className="live-stream-block"
                    item
                    size={{ xs: 12, sm: 6, md: 9 }}
                    style={{
                        position: "relative",
                        height: '100%',
                    }}
                >
                    {/* <div className="live-stream-section"> */}
                    <div
                        id="remote-stream"

                        style={{
                            width: "100%",
                            maxWidth: "100%",
                            height: "100%",
                            aspectRatio: '16/7',
                            borderRadius: '8px',
                            backgroundColor: "black",
                            position: "relative",
                            overflow: "hidden",
                        }}
                        onMouseEnter={() => setShowEndLiveButton(true)}
                        onMouseLeave={() => setShowEndLiveButton(false)}
                    >   
                    <div className="live-pro-box">
                        <div style={{
                            position: "absolute",
                            top: 10,
                            left: 10,
                            color: 'white',
                            // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: "999",
                            borderRadius: "50px",
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <img src={liveData?.stream.sellerId?.image} alt='profile' height={45} width={45} style={{ borderRadius: "50px", objectFit: "cover" }} />
                            <span className="col-sm-8 col-6 video-title text-truncate ps-2"> Box Fan - Low Speed, Black Screen (Vertical)</span>
                        </div>
                        <div className="live-view"
                            style={{
                                position: "absolute",
                                color: 'white',
                                zIndex: "999",
                                borderRadius: "50px",
                                background: "#ffe1e7",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                            }}
                        >
                            <VisibilityIcon sx={{ color: "#e1306c" }} />
                            {numUsers && <span style={{ marginLeft: "5px",  color: "#333" }}>{numUsers - 1}</span>}
                        </div>
                        </div>

                        <div 
                            style={{
                                position: "absolute",
                                bottom: 10,
                                right: 10,
                                color: 'white',
                                zIndex: "999",
                                borderRadius: "50px",
                                background: "#29a6ff",
                                padding: "3px 12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                            }}
                            onClick={handleLikeStream}
                        >
                            
                         { liked ? <ThumbUpIcon sx={{fontSize:"24px"}}/>: <ThumbUpOutlinedIcon sx={{fontSize:"24px"}}/>}
                         <span style={{ marginLeft: "5px", fontSize: "16px", color: "#fff" }}>{likeCount}</span>
                        </div>

                   
                            <div className="cross-btn-box" style={{
                                position: "absolute",
                                top: 5,
                                right: 7,
                                color: 'white',
                                zIndex: "9999",
                                cursor: "pointer",
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                            }}><Button onClick={handleLeave} className="cross-btn"><CloseIcon /></Button></div>
                    <Button
                        onClick={handleLeave}
                        className="end-leave user-leave-btn"
                        variant="contained"
                        color="error"
                        sx={{
                            position: 'absolute',
                            bottom: 10,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 999,
                            backgroundColor: 'rgba(255, 0, 0, 0.7)',
                            '&:hover': { backgroundColor: 'rgba(255, 0, 0, 0.9)' }
                        }}
                    >
                        <CallEndIcon />
                    </Button>
                    </div>
                    {/* </div> */}
                    {/* <Grid2
                    item
                    size={{ xs: 12, sm: 4, md: 4 }}
                    style={{
                        backgroundColor: 'transparent',
                        height: '100%',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                    }}
                    sx={{
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                        scrollbarWidth: 'none',
                    }}
                >
                    
                </Grid2> */}
                    {/* <div className="py-3">
                    <h5 className="col-8 text-truncate">🔴 Box Fan - Low Speed, Black Screen (Vertical)</h5>
                </div> */}
                    <div className="my-2">
                        <ProductGrid products={liveData?.stream?.products} />
                    </div>
                </Grid2>
                {/* chat right side */}
                <Grid2
                    item
                    size={{ xs: 12, sm: 6, md: 3 }}
                    className="chat-board"
                    style={{
                        height: "97vh",
                        padding: "20px",
                        // overflowY: "auto",
                        overflow: 'hidden',
                        // overflowY: 'hidden',
                        backgroundColor: "#f4f4f4",
                        display: "flex",
                        // marginTop: "10px",
                        position: "sticky",
                        top: "0px",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        borderRadius: "10px",
                        border: "1px solid #dbdbdb"

                    }}
                    sx={{
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                        scrollbarWidth: 'none',
                    }}
                >
                    <h5 style={{borderBottom: "1px solid #b9b9b9"}} className="d-sm-block d-none pb-3">Live Support Here</h5>
                    <div
                        id="comments"
                        style={{
                            maxHeight: '80%',
                            overflowY: 'scroll',
                            width: '100%',
                            marginBottom: '20px',
                            flex: 1,
                            paddingRight: '10px',
                        }}
                        className="chat-box"
                    >
                        {comments.map((commentData, index) => (
                            <div key={index}
                                className="chat-box-msg"
                                style={{
                                    padding: '3px 7px',
                                    marginBottom: '10px',
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px 8px 0 8px',
                                    // border: '1px solid #ddd',
                                    // boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                                    maxWidth: '100%',
                                    marginLeft: 'auto',
                                    marginRight: '10px',
                                }}>
                                <div className="profile-box">
                                    <img src={commentData.userId?.image} height={25} width={25} alt="Image" />
                                    <p className="name "><b>{commentData.userId?.name}</b>:- {commentData.comment}</p>
                                </div>

                                {/* <p className="my-1   live-cmt">{commentData.comment}</p> */}
                            </div>
                        ))}
                        <div ref={commentsEndRef} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                        className="chat-input-box"
                    >
                        <TextField
                            label="Type your comment"
                            variant="outlined"
                            fullWidth
                            className="chat-txt"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSendComment();
                                }
                            }}
                            sx={{
                                marginRight: "10px",
                                flex: 1,
                            }}
                        />
                        <IconButton
                            onClick={handleSendComment}
                            className="chat-send-btn"
                            sx={{
                                backgroundColor: "rgba(0, 0, 255, 0.7)",
                                "&:hover": { backgroundColor: "rgba(0, 0, 255, 0.9)" },
                            }}
                        >
                            <SendIcon sx={{ color: "white" }} />
                        </IconButton>
                    </div>
                </Grid2>

            </Grid2>
            <StreamEndPopup open={open} handleClose={handleLeave} />
        </div>
    );
};

export default JoinLive;

